import { Component, OnInit, ViewChild } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { DataTableDirective } from 'angular-datatables';
import { AlertifyService } from 'src/app/recursos/alertify.service';
import { SeleccionService } from '../../servicios/seleccion.service';
import { ToolsService } from '../../recursos/tools.service';
import { LoaderComponent } from '../../servicios/loader/loader.component';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-educativa-inf-atenciones',
  templateUrl: './educativa-inf-atenciones.component.html',
  styleUrls: ['./educativa-inf-atenciones.component.css']
})
export class EducativaInfAtencionesComponent implements OnInit {


  dtOptionsAten: DataTables.Settings = {};
  public dtTriggerAten: Subject<any>;

  public mr: NgbModalRef;
  @ViewChild(DataTableDirective)
  public vecAtenciones = [];
  public encabezado: string = ""; public nombreBeca: string = ""; public fechaIni: string = ''; public fechaFin: string = ''; public banRep = 1;

  constructor(private modalService: NgbModal, private alerti: AlertifyService, private srvSelect: SeleccionService, private tools: ToolsService, private cargando: LoaderComponent) { }

  ngOnInit() {
    this.dtTriggerAten = new Subject<any>();
    this.dtOptionsAten[0] = this.tools.OpcionesTabla(10);

    this.encabezado = "Pisicología educativa";
    this.nombreBeca = localStorage.getItem('modNom');
    this.calculoFecha();
  }

  //FUNCION PARA ABRIR EL MODAL QUE PERMITE EDITAR UN REQUISITO
  buscarFechas(nameMod) {
    if (localStorage.getItem('modUser') == 'true') {
      this.mr = this.modalService.open(nameMod);
    }
    else
      this.alerti.error("Este perfil no tiene permiso para esta actividad");
  }
  //FUNCION QUE SELECCIONA EL TIPO DE REPORTE
  cambiaTipoReporte(op) {
    this.banRep = op;
  }
  //FUNCION QUE INVOCA LOS TIPOS DE REPORTES SELECCIONADOS
  verInformeAtenciones() {
    if (this.banRep == 1)
      this.verInformePorConsulta();
    if (this.banRep == 2)
      this.verInformePorActividad();
  }
  //MOSTRAR EL INFORME DE ATENCIONES POR CONSULTA DADO UN RANGO DE FECHAS
  async verInformePorConsulta() {
    var nombActividades = '';
    var table2 = $('#tblAtenciones').DataTable({
      destroy: true
    });
    table2.destroy();
    this.cerrarModal();

    this.cargando.abrir();
    this.vecAtenciones = [];
    const resInf = await new Promise<any>(resolve =>
      this.srvSelect.gestionPsicologiaE(3, this.fechaIni, this.fechaFin, localStorage.getItem('idPersona'), 'na').subscribe(translated => {
        resolve(translated)
      }));
    if (resInf.success) {
      for (let i in resInf.consulta) {
        nombActividades = '';
        const resAct = await new Promise<any>(resolve =>
          this.srvSelect.gestionPsicologiaE(5, resInf.consulta[i]['intIdConsulta'], 'na', 'na', 'na').subscribe(translated => { resolve(translated) }));
        if (resAct.success) {
          for (let contAct in resAct.consulta)
            nombActividades = nombActividades + '  -(' + resAct.consulta[contAct]['dtFecha'].split('T')[0] + ') ' + resAct.consulta[contAct]['strDetalle'] + '; '
        }

        this.vecAtenciones.push({
          fecha: resInf.consulta[i]['dtFecha'].split('T')[0],
          cedula: resInf.consulta[i]['strPaciente'],
          nombres: '--',
          sexo: '--',
          edad: '--',
          facultad: '--',
          carrera: '--',
          semestre: resInf.consulta[i]['strSemestre'],
          motivo: resInf.consulta[i]['nombMotivo'],
          diagnostico: resInf.consulta[i]['strDiagnostico'],
          actividad: nombActividades,
          etnia: 'No Registra', discapacidad: 'No Registra', genero: 'No Registra', grupo: 'No Registra',
        });

        await this.verHistoria(resInf.consulta[i]['strPaciente'], i);
        const resMatr = await new Promise<any>(resolve =>
          this.srvSelect.gestionMatricula(30, resInf.consulta[i]['strCcarrera'], resInf.consulta[i]['strPaciente'], resInf.consulta[i]['strPeriodo'], 'na').subscribe(translated => {
            resolve(translated)
          }));
        if (resMatr.success) {
          this.vecAtenciones[i]['nombres'] = resMatr.matricula[0]['strNombres'] + ' ' + resMatr.matricula[0]['strApellidos'];
          this.vecAtenciones[i]['sexo'] = resMatr.matricula[0]['strCodSexo'] == 'FEM' ? 'Mujer' : 'Hombre';
          this.vecAtenciones[i]['edad'] = parseInt(resInf.consulta[i]['dtFecha'].split('-')[0]) - parseInt(resMatr.matricula[0]['dtFechaNac'].split('-')[0]);
        }

        const resCarrera = await new Promise<any>(resolve =>
          this.srvSelect.gestionCarreras(4, resInf.consulta[i]['strCcarrera'], 'na', 'na').subscribe(translated => {
            resolve(translated)
          }));
        if (resCarrera.success) {
          this.vecAtenciones[i]['facultad'] = resCarrera.carrera[0]['nombreFacultad'];
          this.vecAtenciones[i]['carrera'] = resCarrera.carrera[0]['nombreCarrera'];
        }

      }
      this.dtTriggerAten.next();
    }
    else
      this.alerti.message('No se encntró información de atenciones');
    this.cargando.cerrar();
  }
  //MOSTRAR EL INFORME DE ATENCIONES POR CONSULTA DADO UN RANGO DE FECHAS
  async verInformePorActividad() {
    var table2 = $('#tblAtenciones').DataTable({
      destroy: true
    });
    table2.destroy();
    this.cerrarModal();

    this.cargando.abrir();
    this.vecAtenciones = [];
    const resInf = await new Promise<any>(resolve =>
      this.srvSelect.gestionPsicologiaE(6, this.fechaIni, this.fechaFin, localStorage.getItem('idPersona'), 'na').subscribe(translated => {
        resolve(translated)
      }));
    if (resInf.success) {
      for (let i in resInf.consulta) {

        this.vecAtenciones.push({
          fecha: resInf.consulta[i]['fechaActividad'].split('T')[0],
          cedula: resInf.consulta[i]['strPaciente'],
          nombres: '--',
          sexo: '--',
          edad: '--',
          facultad: '--',
          carrera: '--',
          semestre: resInf.consulta[i]['strSemestre'],
          motivo: resInf.consulta[i]['nombMotivo'],
          diagnostico: resInf.consulta[i]['strDiagnostico'],
          actividad: resInf.consulta[i]['strDetalle'],
          etnia: 'No Registra', discapacidad: 'No Registra', genero: 'No Registra', grupo: 'No Registra',
        });

        await this.verHistoria(resInf.consulta[i]['strPaciente'], i);

        const resMatr = await new Promise<any>(resolve =>
          this.srvSelect.gestionMatricula(2, resInf.consulta[i]['strCcarrera'], resInf.consulta[i]['strPaciente'], resInf.consulta[i]['strPeriodo'], 'na').subscribe(translated => {
            resolve(translated)
          }));
        if (resMatr.success) {
          this.vecAtenciones[i]['nombres'] = resMatr.matricula[0]['strNombres'] + ' ' + resMatr.matricula[0]['strApellidos'];
          this.vecAtenciones[i]['sexo'] = resMatr.matricula[0]['strCodSexo'] == 'FEM' ? 'Mujer' : 'Hombre';
          this.vecAtenciones[i]['edad'] = parseInt(resInf.consulta[i]['dtFecha'].split('-')[0]) - parseInt(resMatr.matricula[0]['dtFechaNac'].split('-')[0]);
        }

        const resCarrera = await new Promise<any>(resolve =>
          this.srvSelect.gestionCarreras(4, resInf.consulta[i]['strCcarrera'], 'na', 'na').subscribe(translated => {
            resolve(translated)
          }));
        if (resCarrera.success) {
          this.vecAtenciones[i]['facultad'] = resCarrera.carrera[0]['nombreFacultad'];
          this.vecAtenciones[i]['carrera'] = resCarrera.carrera[0]['nombreCarrera'];
        }

      }
      this.dtTriggerAten.next();
    }
    else
      this.alerti.message('No se encntró información de atenciones');
    this.cargando.cerrar();
  }
  //BUSCAMOS LA hce DEL ESTUDIANTE
  async verHistoria(estudiante, pos) {
    const resHC = await new Promise<any>(resolve => this.srvSelect.medicoHistoriaClinica(estudiante).subscribe(translated => {
      resolve(translated)
    }));
    if (resHC.success) {
      await this.verGruposPaciente(4, resHC.roles[0]['NUM_CLINICA'], pos);//ETNIA
      await this.verGruposPaciente(5, resHC.roles[0]['NUM_CLINICA'], pos);//GRUPO VULNERABLE
      await this.verGruposPaciente(6, resHC.roles[0]['NUM_CLINICA'], pos);//DIVERSIDAD SEXUAL
      await this.verGruposPaciente(8, resHC.roles[0]['NUM_CLINICA'], pos);//DISCAPACIDAD
    }
    else {
      this.alerti.warning('El estudiante no dispone de historia clínica, por lo que no muestra datos referentes a etnia, etc.');
    }
  }
  //FUNCION PARA MOSTRAR TODAS LAS DISCAPACIDADES
  async verGruposPaciente(op, param1, pos) {
    const resGrupo = await new Promise<any>(resolve =>
      this.srvSelect.medicoOtrosDatos(op, param1, 'na').subscribe(translated => {
        resolve(translated)
      }));
    if (resGrupo.success) {
      if (op == 4)
        this.vecAtenciones[pos]['etnia'] = resGrupo.consulta[0]['detalle'];
      if (op == 5)
        this.vecAtenciones[pos]['grupo'] = resGrupo.consulta[0]['detalle'];
      if (op == 6)
        this.vecAtenciones[pos]['genero'] = resGrupo.consulta[0]['detalle'];
      if (op == 8)
        this.vecAtenciones[pos]['discapacidad'] = resGrupo.consulta[0]['detalle'] + ' ' + resGrupo.consulta[0]['porcentaje'] + '%';
    }
  }

  //FUNCIÓN QUE CALCULA LA FECHA ACTUAL DEL SISTEMA
  calculoFecha() {
    var hoy = new Date();
    var diahoy = hoy.getDate() < 10 ? "0" + hoy.getDate() : hoy.getDate();
    var meshoy = (hoy.getMonth() + 1) < 10 ? "0" + (hoy.getMonth() + 1) : (hoy.getMonth() + 1);
    var annohoy = hoy.getFullYear();

    this.fechaIni = annohoy + "-" + meshoy + "-" + diahoy;
    this.fechaFin = annohoy + "-" + meshoy + "-" + diahoy;
  }
  //FUNCION QUE CIERRA EL MODAL
  cerrarModal() {
    this.mr.close();
  }
}
